/**
 * Los PDF del chat interno, del lado de la pantalla (dirección, 29/9/2026:
 * «admite poder incorporar pdf y audio en el chat»).
 *
 * Lo que se comprueba aquí es para AVISAR ANTES de subir —un PDF de 30 MB se
 * dice al elegirlo, no después de esperar la barra—, pero la regla la pone
 * el servidor (routers/chat_router.py y services/pdfs_chat.py), que además
 * mira el CONTENIDO del archivo y no solo su nombre. Los topes son los mismos
 * que allí.
 */

// Los mismos topes que el servidor (pdfs_chat.TOPE_BYTES y
// chat_router.TOPE_PDFS).
export const TOPE_MB_PDF = 10;
export const TOPE_BYTES_PDF = TOPE_MB_PDF * 1024 * 1024;
export const TOPE_PDFS = 4;

// Lo que ofrece el clip para los PDF: el tipo y la extensión (hay
// navegadores que no mandan el tipo de un PDF que viene de una unidad de red).
export const ACEPTA_PDF = 'application/pdf,.pdf';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/** ¿Dice ser un PDF? Por su tipo o, si el navegador no lo sabe, por la
 *  extensión. Lo de verdad lo mira el servidor por dentro. */
export function pareceUnPdf(archivo) {
  const tipo = String(archivo?.type || '').toLowerCase();
  if (tipo === 'application/pdf' || tipo === 'application/x-pdf') return true;
  return (!tipo || tipo === 'application/octet-stream') && /\.pdf$/i.test(archivo?.name || '');
}

/** 1536 → «1,5 KB»; 2,5 MB → «2,5 MB». Como lo dice la gente. */
export function tamanoLegible(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.max(1, Math.round(n / 1024))} KB`;
  return `${(n / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}

/** Por qué no vale este PDF, o null si vale. En palabras de la clínica. */
export function motivoNoValidoPdf(archivo) {
  if (!archivo) return 'No se ha podido leer el archivo.';
  const nombre = archivo.name ? `«${archivo.name}»` : 'El PDF';
  if (!archivo.size) return `${nombre} está vacío.`;
  if (archivo.size > TOPE_BYTES_PDF) {
    const mb = (archivo.size / (1024 * 1024)).toFixed(1).replace('.', ',');
    return `${nombre} pesa ${mb} MB y el máximo son ${TOPE_MB_PDF} MB por PDF.`;
  }
  return null;
}

/** La dirección de un PDF de la sala. Con sesión: sin ella, el servidor
 *  contesta 401 (no hay enlaces públicos a los PDF del chat). */
export function urlPdf(sala, id, { descargar = false } = {}) {
  const base = `${BACKEND_URL}/api/chat/salas/${encodeURIComponent(sala)}/pdfs/${encodeURIComponent(id)}`;
  return descargar ? `${base}?descargar=1` : base;
}
